import {createAsyncThunk} from '@reduxjs/toolkit'

import {ROUTER_ORDER_SHEET_SUBSCRIPTION} from '@web/core/routes'
import {changeBrowserLocation} from '@web/helpers/browser'
import {commonSelector} from '@web/slices/common/slice'

import {LocationChangeHistoryParam, NavigationTypeSelectableParam, ThunkApi} from '../interfaces'

type NavigateToShoppingSubscriptionFailParam = LocationChangeHistoryParam & NavigationTypeSelectableParam

const getShoppingSubscriptionFailUrl = (seqID: string) => {
    return `${window.location.origin}${ROUTER_ORDER_SHEET_SUBSCRIPTION.ROOT}/${seqID}/fail`
}

/**
 * 정기구독 실패 페이지로 이동
 */
export const navigateToShoppingSubscriptionFail = createAsyncThunk<
    void,
    NavigateToShoppingSubscriptionFailParam | void,
    ThunkApi
>('navigateTo/shoppingSubscriptionFail', async (args, {getState}) => {
    const state = getState()
    const {seqID} = commonSelector(state)

    changeBrowserLocation({
        type: args?.historyType ?? 'PUSH',
        url: getShoppingSubscriptionFailUrl(seqID),
    })
})

export default navigateToShoppingSubscriptionFail
